module.exports = __webpack_public_path__ + "img/banner03.48195ee9.png";